module.exports = __webpack_public_path__ + "static/img/SHIFTING EFFECT PU products discription1_deskstop.aaea433d.jpg";